module.exports = __webpack_public_path__ + "static/media/view3.3f58392e.jpg";